import { Icon } from "@circle-react/components/shared/Icon";

export const AiIcon = () => (
  <span className="flex items-start">
    <Icon type="20-ask-ai-gradient" size={20} className="size-5" />
  </span>
);
